module.exports = __webpack_public_path__ + "img/slh-right-xian.c5452296.png";